import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import { getPageName } from "../../locales/translationUtils";

const getUserRole = () => {
  const user = sessionStorage.getItem("user") || localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};


const Home: React.FC = () => {
  const [userRole, setUserRole] = useState<string | null>(null);

  useEffect(() => {
    const role = getUserRole();
    setUserRole(role.permission);
  }, []);

  return (
    <div className="container mt-2">
      <h1 className="text-center mb-4">{getPageName("homePage")}</h1>
      <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 g-4">

      {(userRole === "ROLE_MASTER") && (
          <>
            <Card cardName="branch" iconName="people" route="/branch" />
            <Card cardName="cargoInfo" iconName="box" route="/cargo-info" />
            <Card cardName="cargoDocumentType" iconName="file-earmark-text" route="/cargoDocumentType" />
            <Card cardName="cargoSearchList" iconName="filter-square" route="/cargoSearchList" />
            <Card cardName="client" iconName="person" route="/client" />
            <Card cardName="shipInfo" iconName="info-square" route="/shipinfo" />
            <Card cardName="destination" iconName="truck" route="/destination" />
            <Card cardName="release" iconName="check2-square" route="/release" />
            <Card cardName="report" iconName="graph-up" route="/report" />
            <Card cardName="supplier" iconName="person-vcard" route="/supplier" />
            <Card cardName="user" iconName="file-person" route="/user" />
            <Card cardName="warehouseClient" iconName="box-seam" route="/warehouseClient" />
            <Card cardName="warehouse" iconName="houses" route="/warehouse" />
            <Card cardName="warehouseUserClientReportDaily" iconName="table" route="/warehouseUserClientReportDaily" />
          </>
        )}

        {userRole === "ROLE_ADMIN" && (
          <>
            <Card cardName="cargoInfo" iconName="box" route="/cargo-info" />
            <Card cardName="release" iconName="check2-square" route="/release" />
            <Card cardName="report" iconName="graph-up" route="/report" />
          </>
        )}

        {userRole === "ROLE_USER" && (
          <>
            <Card cardName="cargoInfo" iconName="box" route="/cargo-info" />
          </>
        )}

        {userRole === "ROLE_CLIENT" && (
          <>
            <Card cardName="release" iconName="check2-square" route="/release" />
          </>
        )}
      </div>
      <div className="mt-5"></div>
    </div>
  );
};

export default Home;